// flow weak

import React, {
    PureComponent
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import Dialog from 'material-ui/Dialog';
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  import { Multiselect } from 'react-widgets';
  import TimePicker from 'react-times';
  import 'react-times/css/classic/default.css';
  
  
  class AddExpenseTarget extends PureComponent {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      var today = new Date();
      this.years = [today.getFullYear(),today.getFullYear()+1]
      this.months = [1,2,3,4,5,6,7,8,9,10,11,12]
      this.state = { 
        details: {
          venue:'',
          year:today.getFullYear(),
          month:today.getMonth()+1,
          value:0
        },
        venues:[]
      };
      this.handleChange = this.handleChange.bind(this)
      this.handleSubmit = this.handleSubmit.bind(this)
    }
  
    componentDidMount() {
        this.getDetails();
    }  

    getDetails(){
      const url = `${getLocationOrigin()}/get_venue_list/get_venues_for_buddy`;
      const options = {...defaultOptions};

      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => {
            this.setState({venues:data.result},()=>{
              var new_value =  Object.assign({}, this.state.details);
              new_value['venue'] = data.result[0].id
              this.setState({details:new_value})
              this.getExpenseTargetForVenue(data.result[0].id,this.state.details.year,this.state.details.month)
            })           // alert("fix");
         }).catch(error => error);
    }

    getExpenseTargetForVenue(venue,year,month){
      const url = `${getLocationOrigin()}/cm/get_expense_target_for_venue/?venue=${venue}&year=${year}&month=${month}`;
      const options = {...defaultOptions};

      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => {
            var new_value =  Object.assign({}, this.state.details);
            new_value['value'] = data.value
            this.setState({details:new_value})          // alert("fix");
         }).catch(error => error);
    }

    postUpdateBooking(details,props) {
        console.log(details)
        const url = `${getLocationOrigin()}/cm/add_expense_target/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                                          'details': details
                                              });
        console.log('Going to fetch');
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(response=>{  
            console.log('response',response)
            alert(response.message)
            props.history.goBack();
          })
          .catch(error => {
            console.log(error);
            alert(error.message);
          });
      }

    handleChange(event) {
        const name = event.target.name;
        var new_value =  Object.assign({}, this.state.details);
        new_value[name] = event.target.value;
        this.setState({details:new_value})
        if( name == 'venue'){
          this.getExpenseTargetForVenue(event.target.value,this.state.details.year,this.state.details.month);
        }
        else if( name == 'year'){
          this.getExpenseTargetForVenue(this.state.details.venue,event.target.value,this.state.details.month);
        }
        else if( name == 'month'){
          this.getExpenseTargetForVenue(this.state.details.venue,this.state.details.year,event.target.value);
        }
    }

    handleSubmit(event) {
        console.log('handle')
        event.preventDefault();
        console.log('Submit');
        this.postUpdateBooking(this.state.details,this.props)
      }

  
    render() {
      console.log('amount')
      console.log('details',this.state.details)
      

      return(
        <div style={styles.container}> 

          <div className="row col-md-9 table-bordered" style={styles.table}>
            <div style={styles.main_header} className="col-md-12 label_blue_1">
              <h3 style={{textAlign:'center'}}> Add Expense Target</h3>
            </div>
           
              <form  className="validated-form form-horizontal">

                <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Venue
                </div>
               <select name="venue" className="col-md-6" style={styles.item_body} value={this.state.details.venue}
                 onChange={this.handleChange}>
                  {
                     this.state.venues.map((venue,index)=>(
                       <option key={venue.id} value={venue.id}>{venue.name}</option>
                      ))
                   }
               </select>
              </div>

              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Year
                </div>
               <select name="year" className="col-md-6" style={styles.item_body} value={this.state.details.year}
                 onChange={this.handleChange}>
                  {
                     this.years.map((year)=>(
                       <option key={year} value={year}>{year}</option>
                      ))
                   }
               </select>
              </div>

              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Month
                </div>
               <select name="month" className="col-md-6" style={styles.item_body} value={this.state.details.month}
                 onChange={this.handleChange}>
                  { 
                     this.months.map((key)=>(
                       <option key={key} value={key}>{key}</option>
                      ))
                  }
               </select>
              </div>

              
              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Target
                </div>
                <input style={styles.input} name="value" value={this.state.details.value}
                onChange={this.handleChange} />
              </div>
             
              <div style={{display:'flex', flexDirection:'row', padding:'1%', marginLeft:'10px'}}>
                <div style={styles.button_submit} className="col-md-12">
                  <input className="button1" type="submit" value="Add Target" onClick={this.handleSubmit}/>
                </div>
              </div>
                
            </form>
          </div>
        </div>
      );
    }
  }
  
  export default AddExpenseTarget;
  


// WEBPACK FOOTER //
// ./src/app/views/centerportal/crud/addExpenseTarget/AddExpenseTarget.js